import React from "react";
import { Modal } from "react-bootstrap";
import AssignStuffForm from "../Forms/AssignStuffForm";

const AssignStuffToVan = ({ show, handleClose,getStuffVehicle, isAssignToCurrentVehicle, getVehicleById }) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose} dialogClassName="custom-size-Equipment-modal">
        <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
          <Modal.Title className="text-black m-auto">Add Stuff</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{}}>
          <AssignStuffForm getVehicleById={getVehicleById} isAssignToCurrentVehicle={isAssignToCurrentVehicle} handleClose={handleClose} getStuffVehicle={getStuffVehicle} />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AssignStuffToVan;
